<template src="./activateAccount.html"></template>

<script>
import { activate_newAccount } from "@/api/api.account.js";
import mixin from "@/mixin/styleMixin.js";

export default {
  mixins: [mixin],

  data: () => ({
    e1: true,
    alertElaborazione: "",
    tipo: "success",
    disabilitaBtn: false,

    cred: {
      Code: "",
      Password: "",
    },

    style: {
      maxWidth: "300px",
      maxHeight: "420px",
      marginLeft: "auto",
      marginRight: "auto",
    },
  }),

  methods: {
    attiva() {
      // Validazione
      if (this.$refs.formPwd.validate() == false) {
        return;
      }

      if (!this.passwordValita()) {
        this.$toast.error("Errore! La password deve contenere sia lettere che numeri");
        return;
      }

      this.cred.Code = this.$route.query.code;

      this.disabilitaBtn = true;
      this.alertElaborazione = "";

      // Attivazione
      activate_newAccount(this.cred)
        .then((res) => {
          // Vado alla pagina del login
          this.$router.push({ path: "/login" });
        })
        .catch((err) => {
          console.log("attivazione.vue " + err);

          this.tipo = "warning";
          this.alertElaborazione = err.response.data.Message;

          this.disabilitaBtn = false;
        });
    },

    passwordValita() {
      let password = this.cred.Password;
      let carattere = false,
        numero = false;
      for (let i = 0; i < password.length; i++) {
        carattere = this.isCharacterALetter(password[i]);
        if (carattere) break;
      }
      for (let i = 0; i < password.length; i++) {
        if (password[i] >= "0" && password[i] <= "9") {
          numero = true;
          break;
        }
      }
      return carattere && numero;
    },

    isCharacterALetter(char) {
      return /[a-zA-Z]/.test(char);
    },

    checkQueryStringCode() {
      if (this.$route.query.code && this.$route.query.code.length > 0) {
        return true;
      }

      return false;
    },
  },

  mounted() {
    // Controllo querystring
    if (this.checkQueryStringCode() == false) {
      this.alertElaborazione = "Account non valido";
      this.tipo = "warning";
      return;
    }
  },
};
</script>

